import { apiFetch } from './apiClient';
import { BrandConfig } from '../config/types';

const cache: Record<string, BrandConfig> = {};

export async function loadBrandConfigs(): Promise<void> {
  const res = await apiFetch('/api/brands');

  if (!res.ok) throw new Error(`Failed to load brand configs (${res.status})`);

  const rows: { brand_id: string; data: BrandConfig }[] = await res.json();
  for (const row of rows) {
    cache[row.brand_id] = row.data;
  }
}

export function getBrandConfig(brandId: string): BrandConfig {
  const config = cache[brandId];
  if (!config) throw new Error(`Brand configuration not found for: ${brandId}`);
  return config;
}

export function getAllBrandConfigs(): Record<string, BrandConfig> {
  return cache;
}

export function isBrandConfigLoaded(brandId: string): boolean {
  return !!cache[brandId];
}
